/* ==========================================================================
   HEILMANN HOME · Indtoning ved scroll (mockuppens .reveal / .stagger)
   Klasserne saettes fra JS — uden JS er intet skjult, og siden ser normal ud.
   Respekterer prefers-reduced-motion.
   ========================================================================== */
(function () {
  'use strict';

  // Hele blokken toner ind
  var TON = [
    '.hh-gitter-head',
    '.hh-hero__tekst', '.hh-hero__media',
    '.hh-trust__inder',
    '.hh-spot__tekst', '.hh-spot__pics',
    '.hh-look__board', '.hh-look__liste',
    '.hh-ugens__pic', '.hh-ugens__tekst',
    '.hh-fundbog__top',
    '.hh-anm__fordeling', '.hh-anm__panel',
    '.hh-omosbaand',
    '.hh-kol__head', '.hh-maerke__hero',
    '.hh-pdp__galleri', '.hh-pdp__koeb'
  ].join(',');

  // Boernene toner ind én ad gangen
  var TRIN = [
    '.hh-gitter',
    '.hh-kat__net',
    '.hh-prisbaand',
    '.hh-fundbog__liste',
    '.hh-look__ol'
  ].join(',');

  function start() {
    var rolig = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (rolig || !('IntersectionObserver' in window)) return;

    var io = new IntersectionObserver(function (poster) {
      poster.forEach(function (p) {
        if (!p.isIntersecting) return;
        p.target.classList.add('er-inde');
        io.unobserve(p.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    function saml(root) {
      (root || document).querySelectorAll(TON).forEach(function (el) { forbered(el, 'hh-ton'); });
      (root || document).querySelectorAll(TRIN).forEach(function (el) { forbered(el, 'hh-trin'); });
    }

    function forbered(el, klasse) {
      if (el.classList.contains(klasse)) return;
      // Ligger elementet allerede i skaermen ved indlaesning, springer vi
      // animationen over — ellers blinker forsiden, naar man lander paa den.
      var b = el.getBoundingClientRect();
      if (b.top < window.innerHeight * 0.9) { el.classList.add(klasse, 'er-inde'); return; }
      el.classList.add(klasse);
      io.observe(el);
    }

    saml(document);
    // Indhold, der skiftes uden sideskift (filtre, anbefalinger), skal ogsaa med
    document.addEventListener('hh:nytindhold', function (e) { saml(e.detail && e.detail.rod); });
  }

  /* --- Prikker under mobil-banerne ------------------------------------- */
  function prikker() {
    if (!window.matchMedia || !window.matchMedia('(max-width: 900px)').matches) return;
    document.querySelectorAll('.hh-snap').forEach(function (bane) {
      if (bane.dataset.hhPrikker || bane.hasAttribute('data-hh-uden-prikker')) return;
      var boern = [].slice.call(bane.children);
      if (boern.length < 2) return;
      bane.dataset.hhPrikker = '1';

      var d = document.createElement('div');
      d.className = 'hh-prikker' + (bane.dataset.hhPrikkerLys ? ' hh-prikker--lys' : '');
      d.setAttribute('aria-hidden', 'true');
      d.innerHTML = boern.map(function (_, i) { return '<i class="' + (i ? '' : 'er-paa') + '"></i>'; }).join('');
      bane.insertAdjacentElement('afterend', d);

      var t;
      bane.addEventListener('scroll', function () {
        clearTimeout(t);
        t = setTimeout(function () {
          var x = bane.scrollLeft + bane.clientWidth * 0.35;
          var nu = 0;
          boern.forEach(function (k, i) { if (k.offsetLeft - bane.offsetLeft <= x) nu = i; });
          d.querySelectorAll('i').forEach(function (n, i) { n.classList.toggle('er-paa', i === nu); });
        }, 60);
      }, { passive: true });
    });
  }

  /* Hover-billedet paa produktkortene hentes foerst, naar musen naermer sig.
     Delegeret paa document, fordi filtrene udskifter hele gitteret via
     Section Rendering API — listeners paa de enkelte <img> ville forsvinde.
     Gaten er (hover: hover), samme signal som CSS'ens :hover-regel bruger,
     saa telefoner aldrig henter et billede, de ikke kan vise. */
  function hoverBilleder() {
    if (!window.matchMedia || !matchMedia('(hover: hover)').matches) return;

    /* Billedet markeres "klar" foerst, naar det er hentet og afkodet. CSS'en
       toner det kun ind med .er-klar – ellers startede toningen, foer
       billedet var hentet, og det sprang ind midt i animationen. */
    function hent(kort) {
      var b = kort.querySelector('img.hh-alt[data-hh-hover]');
      if (!b) return;
      var klar = function () { b.classList.add('er-klar'); };
      b.addEventListener('load', klar, { once: true });
      /* Vi bestemmer selv tidspunktet – browserens egen "lazy" maa ikke
         udskyde det yderligere. */
      b.loading = 'eager';
      b.src = b.dataset.hhHover;
      b.removeAttribute('data-hh-hover');
      if (b.complete && b.naturalWidth) klar();
    }

    /* Hent i forvejen: kort, der kommer i syne, faar deres hover-billede
       hentet i ro (efter at siden er loadet, saa det ikke tager baandbredde
       fra de synlige billeder). Kun paa enheder med mus. */
    var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (poster) {
      poster.forEach(function (p) {
        if (!p.isIntersecting) return;
        io.unobserve(p.target);
        hent(p.target);
      });
    }, { rootMargin: '200px 0px' }) : null;

    function observer(rod) {
      if (!io) return;
      (rod || document).querySelectorAll('.hh-kort').forEach(function (k) {
        if (k.querySelector('img.hh-alt[data-hh-hover]')) io.observe(k);
      });
    }
    var start2 = function () { setTimeout(function () { observer(document); }, 400); };
    if (document.readyState === 'complete') start2(); else window.addEventListener('load', start2);
    document.addEventListener('hh:nytindhold', function (e) { observer(e.detail && e.detail.rod); });

    /* Sikkerhedsnet: musen naar kortet, foer observeren har hentet. */
    document.addEventListener('pointerover', function (e) {
      if (e.pointerType && e.pointerType !== 'mouse') return;
      var kort = e.target.closest && e.target.closest('.hh-kort');
      if (kort) hent(kort);
    }, { passive: true });

    /* Tastaturbrugere faar det samme, naar fokus lander i kortet. */
    document.addEventListener('focusin', function (e) {
      var kort = e.target.closest && e.target.closest('.hh-kort');
      if (kort) hent(kort);
    }, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { start(); prikker(); hoverBilleder(); });
  } else { start(); prikker(); hoverBilleder(); }
})();
